import { render } from "./IconStepCurrent.vue?vue&type=template&id=4e6c50ff"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__